export default ({ eventBus, eventDefinitions, context }) => {
  eventBus.$on(eventDefinitions.PRODUCT.IMPRESSION, ({ product, positionInList, impressionList }) => {
    //
  })
}
